<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

const props = withDefaults(
    defineProps<{
        percentProgress?: number
    }>(),
    { percentProgress: 0 }
)

const percentProgressData = ref(0)

const progressBarPercent = computed(() => {
    // Safeguard in the case we try to update the percentage to something over 100
    return props.percentProgress <= 100 ? props.percentProgress : 100
})

onMounted(() => {
    percentProgressData.value = props.percentProgress
})
</script>

<template>
    <div class="progress-bar">
        <div class="progress-bar__container">
            <div
                class="progress-bar__progress"
                :style="{ width: progressBarPercent + '%' }"
            />
        </div>
        <div class="progress-bar__text">
            Your data is loading.
        </div>
    </div>
</template>

<style lang="scss" scoped>


.progress-bar {
    &__container {
        background: $sky-blue;
        height: 4px;
        width: 100%;
        border-radius: 3px;
        position: relative;
    }

    &__progress {
        background: $brand-blue;
        border-radius: 3px;
        position: absolute;
        left: 0;
        top: 0;
        height: 4px;
        transition: ease-out width 0.5s;
    }

    &__text {
        text-align: center;
        margin-top: 22px;
        font-size: 15px;
        line-height: 20px;
        color: $slate;
    }
}
</style>
